import { jsxs, jsx } from 'react/jsx-runtime';
import { Typography } from '../Typography/Typography.js';
import { classNames } from '../../utils/functions/classNames/classNames.js';

const Chip = ({ children, icon, className, }) => (jsxs("div", Object.assign({ className: classNames('chip', className, {
        'chip__with-icon': Boolean(icon),
    }) }, { children: [Boolean(icon) && jsx("div", Object.assign({ className: 'chip--icon' }, { children: icon })), jsx(Typography, Object.assign({ variant: 'body_small' }, { children: children }))] })));

export { Chip };
